<template>
    <div>
      <titleBar :title="title" :type="type" :childTitle="childTitle" :param="$route.query"/>
      <div class="jc-page-content couponDetail">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <jc-form :inline="true"  :rules="rules" ref="searchForm" :model="searchForm" class="jc-box-table-search" style="float: none">
              <jc-form-item :label="$t('订单/账单号_')">
               <jc-input v-model="searchForm.serialNumber" >
                 <jc-select v-model="searchForm.source" slot="prepend" :placeholder="$t('订单/账单编号')" @change="searchForm.serialNumber=''">
                  <jc-option :label="$t('全部')" value="all"></jc-option>
                  <jc-option :label="$t('账单')" value="bill"></jc-option>
                  <jc-option :label="$t('订单/账单号_')" value="order"></jc-option>
                </jc-select>
               </jc-input>
              </jc-form-item>
              <jc-form-item :label="$t('交易类型_')">
                <jc-select v-model="searchForm.dealtype" :placeholder="$t('全部')">
                  <jc-option :label="$t('全部')" value=""></jc-option>
                  <jc-option :label="$t('发放')" value="3"></jc-option>
                  <jc-option :label="$t('支付')" value="4"></jc-option>
                  <jc-option :label="$t('绑定')" value="6"></jc-option>
                  <jc-option :label="$t('过期')" value="7"></jc-option>
                  <jc-option :label="$t('返还')" value="9"></jc-option>
                  <jc-option :label="$t('退款')" value="10"></jc-option>
                </jc-select>
              </jc-form-item>

              <jc-form-item :label="$t('交易时间_')">
                <jc-date-picker
                  v-model="month"
                  type="month"
                  value-format="timestamp"
                  :placeholder="$t('选择月')"
                  @change="handleTime">
                </jc-date-picker>
              </jc-form-item>
              <jc-form-item>
                <jc-button type="primary" @click="onSubmit">{{ $t('查询') }}</jc-button>
                <jc-tooltip :disabled="!!month" effect="light" content="交易时间必选" placement="top" style="margin-left:8px">
                  <span>
                  <jc-button type="primary" :disabled="!month" @click="exportData">{{ $t('导出') }}</jc-button>
                  </span>
                </jc-tooltip>
              </jc-form-item>
            </jc-form>
          </div>
          <jc-table :empty-text="$t('暂无明细信息')" :data="DetailData" style="width: 100%">
            <jc-table-column  prop="orderNumber" :label="$t('订单/账单号')" :min-width="'120'" ></jc-table-column>
            <jc-table-column prop="source" :label="$t('扣款来源')" :min-width="'90'" >
              <template slot-scope="scope" >
                {{ scope.row.source | filterSource }}
              </template>
            </jc-table-column>
            <jc-table-column prop="type" :label="$t('交易类型')" :min-width="'90'" >
              <template slot-scope="scope" >
                {{ scope.row.opType | filterPayType }}
              </template>
            </jc-table-column>
            <jc-table-column  prop="couponNumber" :label="$t('代金券编号')" :min-width="'90'" ></jc-table-column>

            <jc-table-column  :label="$t('收入_元_')" :min-width="'120'" >
              <template slot-scope="scope" >
                {{scope.row.income |formatMoney}}
              </template>
            </jc-table-column>
            <jc-table-column  :label="$t('支出_元_')" :min-width="'120'" >
              <template slot-scope="scope" >
                {{scope.row.expense |formatMoney}}
              </template>
            </jc-table-column>
            <jc-table-column  :label="$t('余额_元_')" :min-width="'120'" >
              <template slot-scope="scope" >
                {{scope.row.balance |formatMoney}}
              </template>
            </jc-table-column>
            <jc-table-column prop="createTime" :label="$t('交易时间')" :min-width="'160'" >
              <template slot-scope="scope">
                {{scope.row.createTime | IETimeFormat}}
              </template>
            </jc-table-column>
          </jc-table>

          <div class="jc-container-table-actionBar">
            <div class="block" :class="{hide:vlock==false}">
              <jc-pagination align="right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="[10,20,50]"
                layout="total, sizes, prev, pager, next"
                :total="total">
              </jc-pagination>
            </div>
          </div>
        </div>
        <div class="buildCon hide" id="con-tab-2">2</div>
        <div class="buildCon hide" id="con-tab-3">3</div>
      </div>
    </div>
  </template>
  <script>
import getTranslation from '@/i18n/getTranslation'
import titleBar from '@/components/titleBar'
import { describeCoupon, couponDetail, exportExcel } from '@/api/coupon-api.js'
export default {
  name: 'couponDetail',
  filters: {
    filterSource(_source) {
      // -1，其他；1，内部系统；2，订单；3，账单；4，uc_web
      _source = Number(_source) || -1
      switch (_source) {
        case -1:
          return getTranslation('其他')
        case 1:
          return getTranslation('内部系统')
        case 2:
          return getTranslation('订单')
        case 3:
          return getTranslation('账单')
        case 4:
          return 'uc_web'
      }
    }
  },

  data() {
    return {
      rules: {
        beginTime: [
          {
            required: true,
            // validator: checkDateStart,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            required: true,
            // validator: checkDateEnd,
            trigger: 'change'
          }
        ]
      },
      title: getTranslation('代金券管理'),
      childTitle: getTranslation('使用明细'),
      type: 'back',
      month: '',
      tabDefaultChoice: 0,
      vlock: true,
      pageNum: 1,
      pageSize: 10,
      total: 10,
      currentPage: 1,
      DetailData: [],
      searchForm: {
        couponNumber: '',
        beginTime: '',
        endTime: '',
        dealtype: '',
        source: 'all',
        serialNumber: ''
      },
      derivativeConfig: window.derivativeConfig
    }
  },
  components: {
    titleBar
  },

  methods: {
    handleTime(val) {
      if (!val) {
        this.searchForm.beginTime = ''
        this.searchForm.endTime = ''
      } else {
        const arr = val.split('-')
        const year = arr[0]
        const month = arr[1]
        const day = new Date(
          new Date(year, month, 1).getTime() - 24 * 60 * 60 * 1000
        ).getDate()
        this.searchForm.beginTime = `${year}-${month}-01`
        this.searchForm.endTime = `${year}-${month}-${day}`
      }
    },
    // http://xingyun.jd.com/codingRoot/jcloud-api-gateway/jcloud-open-api-doc/blob/internal/coupon/coupon%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/exportExcel.md
    async exportData() {
      try {
        this.searchForm.couponNumber = this.$route.query.id
        await exportExcel({
          params: {
            ...this.searchForm
          }
        })
        window.open(derivativeConfig.exportUrl, '_blank')
      } catch (err) {
        console.log(err)
      }
    },
    async onSubmit() {
      //起始日期需要转化2017-06-06格式
      // var _self = this
      this.searchForm.couponNumber = this.$route.query.id
      //请求搜索框+当前页码+每页数量
      var _par = Object.assign(
        { pageSize: this.pageSize, currentPage: this.currentPage },
        this.searchForm
      )
      try {
        let { result = {} } = await describeCoupon({ params: _par })
        //填充table list数据
        this.DetailData = result.data || []
        this.total = (result.pageInfo && result.pageInfo.totalRecord) || 0
      } catch (err) {
        console.log(err)
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      // this.getDetailListData(this.currentPage,this.pageSize)
      this.onSubmit()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.onSubmit()

      // this.getDetailListData(this.currentPage,this.pageSize)
    },
    //初始请求 pageSize currentPage couponNumber
    async getDetailListData(num, ind) {
      this.pageSize = ind
      try {
        let res = await couponDetail({
          couponNumber: this.$route.query.id,
          currentPage: num,
          pageSize: ind || 10
        })
        this.DetailData = res.body.result && res.body.result.data
        this.total =
          (res.body.result &&
            res.body.result.pageInfo &&
            res.body.result.pageInfo.totalRecord) ||
          0
        this.$store.dispatch('setLoadingAct', false)
      } catch (err) {
        this.$store.dispatch('setLoadingAct', false)
      }
    }
  },
  created() {
    // this.getDetailListData(this.currentPage, 10)
    this.onSubmit()
    this.couponNumber = this.$route.query.id
  },
  mounted: function() {}
}
</script>

<style lang="less">
.couponDetail {
  .el-form .el-input,
  .el-form .el-textarea {
    width: 220px;
  }
  .buildCon {
    border: none;
  }
}
.detail-pagination .jc-pager .btn-quicknext + .number {
  display: none;
}
.jc-select .jc-input {
  width: 100px;
}
</style>
